import { useLocation, useNavigate } from "react-router-dom";
import CreatePage from "../../controls/CreatePage";
import PageSection from "../../controls/PageSection";
import Input from "../../controls/Input";
import Textarea from "../../controls/TextArea";
import { useEffect, useState } from "react";
import ImageUpload from "../../controls/ImageUpload";
import { uploadImagesToServer } from "../../../../uploadImageToServer";
import CustomSwitch from "../../controls/CustomSwitch";
import Select from "../../controls/Select";
import { handleAddStore, checkIfStoreCodeIsUnique, fetchStore, handleEditStore } from "../../../api/storeApi";
import { toast } from "react-toastify";
import { getPinCodeStoreDomain, getPinCodeStoreType } from "../../controls/Pincode";
import { allState } from "../../CRM/customer/allStateNameOfIndia";
import { useDispatch, useSelector } from "react-redux";
import { selectRegistration } from "../../../redux/slices/userSlice";
import { selectSalesTransactionType } from "../../../redux/slices/transactionTypeSlice";
import Icon from "../../../assets/icons/Icon";
import { FaTimes } from "react-icons/fa";
import Button from "../../controls/Button";
import { selectStoreModule } from "../../../redux/slices/customFieldSlice";
import Loading from "../../controls/Loading";
import { usePhoneNoValidation } from "../../controls/CommonFunctions";
import Autocompletesearch from "../../controls/Autocompletesearch";
import { setStore } from "../../../redux/slices/storeSlice";
import InfoModal from "../../controls/InfoModal";

const AddStoreData = () => {
  // Redux selectors
    const dispatch = useDispatch();
    const { getPhoneNumberDigit, getDialCode } = usePhoneNoValidation();
    console.log("getPhoneNumberDisigt",getPhoneNumberDigit(),"getdialcode",getDialCode());
  const location = useLocation();
  let onSave=null;
  const navigate = useNavigate();
  const customFieldData = useSelector(selectStoreModule);
  const selectedStore = useSelector((state) => state.store.store);
  const registration = useSelector(selectRegistration);
  const salesTransactionTypes = useSelector(selectSalesTransactionType);
  const user = useSelector((state) => state.user.user);
   const stores = useSelector((state) => state.store.storesList);

      const [showInfoModal,setShowInfoModal]=useState(false);
      const [infoType,setInfoType]=useState("");

  // State initialization
  const [storeData, setStoreData] = useState(null);
  const [isPincode, setIsPincode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("");

  // Store Information
  const [storeCode, setStoreCode] = useState("");
  const [storeName, setStoreName] = useState("");
  const [emailID, setEmailID] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState(registration?.Country);
  const [currency, setCurrency] = useState("");
  const [fiscalYearMonth, setFiscalYearMonth] = useState("");
  const [language, setLanguage] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [locality, setLocality] = useState("");

  // Store Settings
  const [cashRegisterClosingSelected, setCashRegisterClosingSelected] = useState(false);
  const [changeQtyOnPriceUpdate, setChangeQtyOnPriceUpdate] = useState(false);
  const [cashRegisterClosingIncludeProductSaleDetails, setCashRegisterClosingIncludeProductSaleDetails] = useState(false);
  const [negativeProductQtyNotAllowedForBilling, setNegativeProductQtyNotAllowedForBilling] = useState(false);
  const [enableFoodDeliveryPlatforms, setEnableFoodDeliveryPlatforms] = useState(false);
  const [urbanPiperIntegration, setUrbanPiperIntegration] = useState(false);
  const [salesProductSearch, setSalesProductSearch] = useState(1);
  const [inventoryProductSearch, setInventoryProductSearch] = useState(1);
  const [kotPrinter, setKotPrinter] = useState("");
  const [desktopOption, setDesktopOption] = useState("");
  const [enableTableOrder, setEnableTableOrder] = useState(false);
  const [tableOrderTransactionTypeID, setTableOrderTransactionTypeID] = useState("");
  const [disableCustomerCreationAndEdit, setDisableCustomerCreationAndEdit] = useState(false);

  // Delivery Settings
  const [deliveryRadius, setDeliveryRadius] = useState("");
  const [deliveryCharge, setDeliveryCharge] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [deliveryTimeType, setDeliveryTimeType] = useState("min");
  const [shipTime, setShipTime] = useState("");
  const [shipTimeType, setShipTimeType] = useState("min");
  const [deliveryType, setDeliveryType] = useState("");
  const [customerPickUp, setCustomerPickUp] = useState(false);

  // Location
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [place, setPlace] = useState({ Address: "", Lat: "", Lng: "" });

  // Store Media
  const [logo, setLogo] = useState(null);
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [images, setImages] = useState([]);
  const [imgLoading, setimgLoading] = useState(false);
  const [logoLoading, setLogoLoading] = useState(false);

  // Online Ordering
  const [autoAcceptOnlineOrders, setAutoAcceptOnlineOrders] = useState(false);
  const [acceptOnlineOrders, setAcceptOnlineOrders] = useState(false);
  const [googleReviewLink, setGoogleReviewLink] = useState("");
  const [showProductsOnlineAvailabilityBasedOnOutOfStock, setShowProductsOnlineAvailabilityBasedOnOutOfStock] = useState(false);

  // Store Timing
  const storeTimingDefault = [
    { Day: "Monday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
    { Day: "Tuesday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
    { Day: "Wednesday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
    { Day: "Thursday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
    { Day: "Friday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
    { Day: "Saturday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
    { Day: "Sunday", Open: false, StartTime: { HH: "", MM: "", AMPM: "" }, EndTime: { HH: "", MM: "", AMPM: "", Error: "" } },
  ];
  const [storeTiming, setStoreTiming] = useState(storeTimingDefault);

  // Food Delivery Platforms
  const foodDeliveryPlatformsOptions = [
    { Code: "swiggystore", Name: "Swiggy Stores" },
    { Code: "zomatomarket", Name: "Zomato Market" },
    { Code: "swiggy", Name: "Swiggy" },
    { Code: "zomato", Name: "Zomato" },
    { Code: "ubereats", Name: "Uber Eats" },
    { Code: "urbanpiper", Name: "Urban piper" },
    { Code: "satellite", Name: "Satellite" },
  ];
  const [foodDeliveryPlatforms, setFoodDeliveryPlatforms] = useState(foodDeliveryPlatformsOptions);

  // Store Domain
  const [domain, setDomain] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);
  const [storeDomainID, setStoreDomainID] = useState("");
  const [storeTypeID, setStoreTypeID] = useState("");
  const [pincodeHashKey, setPincodeHashKey] = useState("");

  // Custom Fields
  const [customField1, setCustomField1] = useState("");
  const [customField2, setCustomField2] = useState("");
  const [customField3, setCustomField3] = useState("");
  const [customField4, setCustomField4] = useState("");
  const [customField5, setCustomField5] = useState("");
  const [customField6, setCustomField6] = useState("");

  // Error States
  const [storeNameError, setStoreNameError] = useState("");
  const [storeCodeError, setStoreCodeError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [emailIDError, setEmailIDError] = useState("");
  const [address1Error, setAddress1Error] = useState("");
  const [localityError, setLocalityError] = useState("");
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [latError, setLatError] = useState("");
  const [lonError, setLonError] = useState("");
  const [storeDomainError, setStoreDomainError] = useState("");
  const [storeTypeError, setStoreTypeError] = useState("");

  // Other
  const [lockStoreConfig, setLockStoreConfig] = useState(false);
  const [tmplockStoreConfig, setTmplockStoreConfig] = useState(false);
  const [states, setStates] = useState(allState);
  const [minPickUptime, setMinPickUptime] = useState(0);
  const [minDeliveryTime, setMinDeliveryTime] = useState(0);
  const [minOrderValue, setMinOrderValue] = useState(0);
 
  // Initialize component
  useEffect(() => {
    setDomain(getPinCodeStoreDomain());
    setStates(allState);
      onSave=location?.state?.onSave;
    if (location?.state?.store) {
      const store = location.state.store;
    
      setStoreData(store);
      setKey(store.key || "");
    } else {
           let storeCount = stores.filter((f) => !f.IsDeleted).length;
      if (
        registration.hasOwnProperty(
          "NoOfStoresAllowed"
        ) &&
      registration?.NoOfStoresAllowed > storeCount
      ) {
      } else {
   toast.info("You cannot add more stores because your store limit has been reached. Please upgrade your plan or contact our support team at support@posible.in if you would like to increase your store limit.");
        navigate(-1);
      }
    
    }
  }, [location, registration, stores, navigate]);

  // Initialize state from storeData
  useEffect(() => {
    if (storeData) {
      setStoreCode(storeData.StoreCode || "");
      setStoreName(storeData.StoreName || "");
      setEmailID(storeData.EmailID || "");
      setPhoneNo(storeData.PhoneNo || "");
      setAddress1(storeData.Address1 || "");
      setAddress2(storeData.Address2 || "");
      setCity(storeData.City || "");
      setState(storeData.State || "");
      setStateCode(storeData.StateCode || "");
      setPostalCode(storeData.PostalCode || "");
      setCountry(storeData.Country || "");
      setCurrency(storeData.Currency || "");
      setFiscalYearMonth(storeData.FiscalYearMonth || "");
      setLanguage(storeData.Language || "");
      setTimeZone(storeData.TimeZone || "");
      setCashRegisterClosingSelected(storeData.CashRegisterClosing || false);
      setChangeQtyOnPriceUpdate(storeData.ChangeQtyOnPriceUpdate || false);
      setCashRegisterClosingIncludeProductSaleDetails(storeData.CashRegisterClosingIncludeProductSaleDetails || false);
      setCustomField1(storeData.CustomField1 || "");
      setCustomField2(storeData.CustomField2 || "");
      setCustomField3(storeData.CustomField3 || "");
      setCustomField4(storeData.CustomField4 || "");
      setCustomField5(storeData.CustomField5 || "");
      setCustomField6(storeData.CustomField6 || "");
      setNegativeProductQtyNotAllowedForBilling(storeData.NegativeProductQtyNotAllowedForBilling || false);
      setEnableFoodDeliveryPlatforms(storeData.EnableFoodDeliveryPlatforms || false);
      setMinPickUptime(storeData.MinPickUptime || 0);
      setMinDeliveryTime(storeData.MinDeliveryTime || 0);
      setMinOrderValue(storeData.MinOrderValue || 0);
      setUrbanPiperIntegration(storeData.UrbanPiperIntegration || false);
      setStoreTiming(storeData.StoreTiming || storeTimingDefault);
      setSalesProductSearch(storeData.SalesProductSearch || 1);
      setInventoryProductSearch(storeData.InventoryProductSearch || 1);
      setKotPrinter(storeData.KOTPrinter || "");
      setLatitude(storeData.Location?.lat || "");
      setLongitude(storeData.Location?.lon || "");
      setDesktopOption(storeData.DesktopOption || "");
      setEnableTableOrder(storeData.EnableTableOrder || false);
      setTableOrderTransactionTypeID(storeData.TableOrderTransactionTypeID || "");
      setDeliveryRadius(storeData.DeliveryRadius || "");
      setDeliveryCharge(storeData.DeliveryCharge || "");
      setDeliveryTime(storeData.DeliveryTime || "");
      setShipTime(storeData.ShipTime || "");
      setShipTimeType(storeData.ShipTimeType || "min");
      setCustomerPickUp(storeData.CustomerPickUp || false);
      setLogo(storeData.Logo || null);
      setShortDescription(storeData.ShortDescription || "");
      setLongDescription(storeData.LongDescription || "");
      setImages(storeData.Images || []);
      setAutoAcceptOnlineOrders(storeData.AutoAcceptOnlineOrders || false);
      setAcceptOnlineOrders(storeData.AcceptOnlineOrders || false);
      setGoogleReviewLink(storeData.GoogleReviewLink || "");
      setShowProductsOnlineAvailabilityBasedOnOutOfStock(storeData.ShowProductsOnlineAvailabilityBasedOnOutOfStock || false);
      setLocality(storeData.Locality || "");
      setStoreDomainID(storeData.StoreDomainID || "");
      setStoreTypeID(storeData.StoreTypeID || "");
      setPincodeHashKey(storeData.PincodeHashKey || "");
      setLockStoreConfig(storeData.LockStoreConfig || false);
      setTmplockStoreConfig(storeData.LockStoreConfig || false);

      // Initialize food delivery platforms
      if (storeData.FoodDeliveryPlatforms) {
        const updatedPlatforms = foodDeliveryPlatformsOptions.map(platform => {
          const found = storeData.FoodDeliveryPlatforms.find(p => p.Code === platform.Code);
          return found ? { ...platform, Selected: true, TransactionTypeID: found.TransactionTypeID, PriceMarkUp: found.PriceMarkUp } : platform;
        });
        setFoodDeliveryPlatforms(updatedPlatforms);
      }
    }
  }, [storeData]);

  const onStoreDomainSelected = (value) => {
    const storeTypes = getPinCodeStoreType(value);
    setStoreDomainID(value);
    setStoreTypes(storeTypes);
    setStoreDomainError("");
  };

  const isValidLatitude = (latitude) => {
    return /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(latitude);
  };

  const isValidLongitude = (longitude) => {
    return /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(longitude);
  };

  const handleImageUpload = async (image, type) => {
    if (type === "logo") {
      setLogoLoading(true);
    } else {
      setimgLoading(true);
    }

    try {
      const uploadurl = await uploadImagesToServer(image);

      if (uploadurl) {
        const imageInfo = {
          ImageName: image.name,
          ImagePath: uploadurl,
          ImageSize: image.size
        };

        if (type === "logo") {
          setLogo(imageInfo);
        } else if (images.length < 4) {
          setImages((prevImgArray) => [...prevImgArray, imageInfo]);
        }
      }
    } catch (error) {
      toast.error("Failed to upload image");
    } finally {
      setimgLoading(false);
      setLogoLoading(false);
    }
  };

  const handleImageDelete = (index) => {
    const newImgArray = images.filter((_, i) => i !== index);
    setImages(newImgArray);
  };

  const handleOnSave = async () => {
   

    // Validation
    let storeCodeError = "";
    let storeNameError = "";
    let phoneNoError = "";
    let address1Error = "";
    let localityError = "";
    let cityError = "";
    let stateError = "";
    let postalCodeError = "";
    let latError = "";
    let lonError = "";


      if (phoneNo.length !== getPhoneNumberDigit()) {
        phoneNoError=`Phone number should be ${getPhoneNumberDigit()} digits`;
      }
 
    if(imgLoading || logoLoading){
      toast.info("Please wait for uploading image then try...");
      return;
    }

    if (storeCode.trim() === "") {
      storeCodeError = "Please provide store code";
    }
    if (storeName.trim() === "") {
      storeNameError = "Please provide store name";
    }

    // Check store code uniqueness
    const params = {
      storeCode: storeCode,
      storeID: key,
    };

   

    if (isPincode) {
      if (phoneNo === "") {
        phoneNoError = "Please provide store contact no";
      }
      if (address1.trim() === "") {
        address1Error = "Please provide value";
      }
      if (locality.trim() === "") {
        localityError = "Please provide value";
      }
      if (city.trim() === "") {
        cityError = "Please provide value";
      }
      if (state.trim() === "") {
        stateError = "Please provide value";
      }
      if (postalCode.trim() === "") {
        postalCodeError = "Please provide value";
      }
      if (latitude === "") {
        latError = "Please provide value";
      } else if (!isValidLatitude(latitude)) {
        latError = "Latitude is incorrect";
      }
      if (longitude === "") {
        lonError = "Please provide value";
      } else if (!isValidLongitude(longitude)) {
        lonError = "Longitude is incorrect";
      }
    }
 
    // Set error states
  

    // Check if any errors exist
    if (
      storeCodeError!=="" || storeNameError!=="" || phoneNoError!=="" ||
      address1Error!=="" || localityError!=="" || cityError!=="" ||
      stateError!=="" || postalCodeError!=="" || latError!=="" || lonError!==""
    ) {
      setStoreCodeError(storeCodeError);
    setStoreNameError(storeNameError);
    setPhoneNoError(phoneNoError);
    setAddress1Error(address1Error);
    setLocalityError(localityError);
    setCityError(cityError);
    setStateError(stateError);
    setPostalCodeError(postalCodeError);
    setLatError(latError);
    setLonError(lonError);
      return;
    }
        setLoading(true);
  if(storeCode){
    try {
      const response = await checkIfStoreCodeIsUnique(params);
      if (!response?.isUnique) {
        storeCodeError = "Store code already exists";
          setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to verify store code");
      setLoading(false);
      return;
    }
  }

    // Prepare store data
    const store = {
      StoreDomainID: storeDomainID || registration?.StoreDomainID || "",
      StoreTypeID: storeTypeID || registration?.StoreTypeID || "",
      PincodeHashKey: pincodeHashKey || registration?.PincodeHashKey || "",
      StoreCode: storeCode,
      StoreName: storeName,
      EmailID: emailID,
      PhoneNo: phoneNo,
      Address1: address1,
      Address2: address2,
      Locality: locality,
      City: city,
      State: state,
      StateCode: stateCode,
      PostalCode: postalCode,
      Country: country,
      Currency: currency,
      FiscalYearMonth: fiscalYearMonth,
      Language: language,
      TimeZone: timeZone,
      CashRegisterClosing: cashRegisterClosingSelected,
      CashRegisterClosingIncludeProductSaleDetails: cashRegisterClosingIncludeProductSaleDetails,
      CustomField1: customField1,
      CustomField2: customField2,
      CustomField3: customField3,
      CustomField4: customField4,
      CustomField5: customField5,
      CustomField6: customField6,
      RegistrationID: user.RegistrationID,
      ChangeQtyOnPriceUpdate: changeQtyOnPriceUpdate,
      NegativeProductQtyNotAllowedForBilling: negativeProductQtyNotAllowedForBilling,
      EnableFoodDeliveryPlatforms: enableFoodDeliveryPlatforms,
      MinPickUptime: minPickUptime,
      MinDeliveryTime: minDeliveryTime,
      MinOrderValue: minOrderValue,
      FoodDeliveryPlatforms: foodDeliveryPlatforms.filter(f => f.Selected),
      StoreTiming: storeTiming,
      SalesProductSearch: salesProductSearch,
      InventoryProductSearch: inventoryProductSearch,
      IsDeleted: false,
      KOTPrinter: kotPrinter,
      DesktopOption: desktopOption,
      EnableTableOrder: enableTableOrder,
      TableOrderTransactionTypeID: tableOrderTransactionTypeID,
      DeliveryRadius: deliveryRadius,
      DeliveryCharge: deliveryCharge,
      DeliveryTime: deliveryTime,
      DeliveryTimeType: deliveryTimeType,
      DisableCustomerCreationAndEdit: disableCustomerCreationAndEdit,
      DeliveryType: deliveryType,
      CustomerPickUp: customerPickUp,
      Logo: logo,
      ShortDescription: shortDescription,
      LongDescription: longDescription,
      Images: images,
      AutoAcceptOnlineOrders: autoAcceptOnlineOrders,
      AcceptOnlineOrders: acceptOnlineOrders,
      GoogleReviewLink: googleReviewLink,
      ShipTime: shipTime,
      ShipTimeType: shipTimeType,
      ShowProductsOnlineAvailabilityBasedOnOutOfStock: showProductsOnlineAvailabilityBasedOnOutOfStock,
      LockStoreConfig: tmplockStoreConfig,
      Location: {
        lat: latitude || "0",
        lon: longitude || "0"
      },
      ...(key && { key: key })
    };

    try {
      let response;
      if (key === "") {
        response = await handleAddStore(store);
      } else {
        response = await handleEditStore(store);
      }


      console.log("response",response);

      if (response?.code === "0") {
        toast.success(key ? "Store updated successfully" : "New Store created successfully");
        if(storeData?.key== selectedStore?.key){
          console.log("same store found",response.data);
          
           dispatch(setStore(response.data));
        }
        
        if(onSave){
 onSave(response.data);
 console.log("onsave calling");
        }
        else{
          console.log("onsave not calling");
        }
       
     
      } else {
        toast.error(response?.message || (key ? "Failed to update store" : "Failed to create store"));
      }
    } catch (error) {
      console.log("error",error);
      toast.error("An error occurred while saving store data");
    } finally {
        setTimeout(() => {
    setLoading(false);
    navigate(-1);
  }, 5000); // 5000 ms = 5 seconds
      
    }
  };

  return (
    <CreatePage
      title={key ? "Edit Store" : "Add Store"}
      handleCancel={() => {navigate(-1)}}
      handleSave={handleOnSave}
    >{loading ? <Loading /> :

      <div className="grid gap-4">
        {/* General Details Section */}
        <PageSection title="General Details">
          <div className="grid gap-3 mt-5">
            <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-3">
              <Input
                isMandatory={true}
                label="Store Code"
                value={storeCode}
                onChange={(e) => { setStoreCode(e.target.value); setStoreCodeError("") }}
                errorMessage={storeCodeError}
                required
              />
              <Input
                isMandatory={true}
                label="Store Name"
                placeholder="Enter your Store Name"
                value={storeName}
                onChange={(e) => { setStoreName(e.target.value); setStoreNameError("") }}
                errorMessage={storeNameError}
                required
              />
              <Input
                label="Phone Number"
                isMandatory={isPincode && true}
                value={phoneNo}
    onChange={(e) => {
                if (e.target.value.length <= getPhoneNumberDigit()) {
                  setPhoneNo(e.target.value);
                  setPhoneNoError("");
                }
              }}
                errorMessage={phoneNoError}
                type="number"
                starttext={getDialCode()}

              />
              <Input
                label="Email ID"
                value={emailID}
                onChange={(e) => { setEmailID(e.target.value); setEmailIDError("") }}
                errorMessage={emailIDError}
                starttext={<span className="w-5"><Icon type="email" /></span>}
              />
            </div>
            <div className="grid gap-4 md:grid-cols-2">
              <Textarea
                label="Short Description"
                rows={4}
                placeholder="short description..."
                value={shortDescription}
                onChange={(e) => setShortDescription(e.target.value)}
              />
              <Textarea
                label="Long Description"
                rows={4}
                placeholder="Long Description..."
                value={longDescription}
                onChange={(e) => setLongDescription(e.target.value)}
              />
            </div>
          </div>
        </PageSection>

        {/* Address Section */}
        <PageSection title="Address">
          <div className="grid gap-3 mt-5">
            <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-3">
              <Input
                label="Line Address 1"
                isMandatory={isPincode}
                placeholder="Line Address 1"
                value={address1}
                onChange={(e) => { setAddress1(e.target.value); setAddress1Error("") }}
                errorMessage={address1Error}

              />
              <Input
                isMandatory={isPincode}
                label="Line Address 2"
                placeholder="Line Address 2"
                value={address2}
                onChange={(e) => setAddress2(e.target.value)}
              />
              <Input
                label="Locality"
                placeholder="Enter your locality"
                value={locality}
                onChange={(e) => { setLocality(e.target.value); setLocalityError("") }}
                errorMessage={localityError}

              />
              <Input
                isMandatory={isPincode}
                label="City"
                placeholder="Enter your city"
                value={city}
                onChange={(e) => { setCity(e.target.value); setCityError("") }}
                errorMessage={cityError}

              />
              {(country === "India" || country === "") && 
              <>
              <Autocompletesearch
              isMandatory={isPincode}
              label={"State"}
              value={state}
              onChange={()=>{setState(""),setStateCode("")}}
              data={states.map((data) => ({
                        value: data.code,
                        label: data.name,
                      }))}
                          defaultDataCount={20}
            filterKey={["label"]}
                        onSelect={(e) => {
                        setStateCode(e.value);
                        setState(e.label);
                        setStateError("");
                      }}
                  errorMessage={stateError}
                    renderSuggestion={(state) => (
              <div>
                <p className="">{state.label}</p>
              </div>
            )}
/>
                {/* <Select
                  fetchAllObject={true}
                  label="State"
                  value={stateCode}
                 options={states.map((data) => ({
                        value: data.code,
                        label: data.name,
                      }))}
                  onChange={(e) => {
                        setStateCode(e.value);
                        setState(e.label);
                        setStateError("");
                      }}
                  errorMessage={stateError}

                /> */}
                </>
              }
              <Input
                isMandatory={isPincode}
                label="Postal Code"
                placeholder="Enter postal code"
                value={postalCode}
                onChange={(e) => {
                  if (e.target.value.length <= 6) {
                    setPostalCode(e.target.value);
                    setPostalCodeError("");
                  }
                }}
                errorMessage={postalCodeError}

              />
              <Input
                label="Country"
                placeholder="Enter your country"
                value={country}
                disabled={true}
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>

            <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-3">
              <Input
                isMandatory={isPincode}
                label="Latitude"
                placeholder="Enter your latitude"
                value={latitude}
                onChange={(e) => { setLatitude(e.target.value); setLatError("") }}
                errorMessage={latError}

              />
              <Input
                isMandatory={isPincode}
                label="Longitude"
                placeholder="Enter your Longitude"
                value={longitude}
                onChange={(e) => { setLongitude(e.target.value); setLonError("") }}
                errorMessage={lonError}

              />
            </div>
          </div>
        </PageSection>

        {/* Logo and Images Section */}
   <PageSection title="Logo and Images">
  <div className="mt-5">
    <div className="flex flex-wrap items-start gap-4">
      {/* Logo Upload */}
      <div className="image-preview-container w-full md:w-auto">
        {logoLoading ? (
          <p>Uploading...</p>
        ) : (
          <ImageUpload
            onImagedelete={() => setLogo(null)}
            onImageChange={(image) => handleImageUpload(image, "logo")}
            isMultiple={false}
            imageData={logo?.ImagePath || null}
            title="Logo"
          />
        )}
      </div>

      {/* Images Upload */}
      {imgLoading ? (
        <p>Uploading...</p>
      ) : (
        images.length < 4 && (
          <div className="image-preview-container w-full md:w-auto">
            <ImageUpload
              onImagedelete={() => setImages([])}
              onImageChange={(image) => handleImageUpload(image, "images")}
              title="Images"
              isMultiple={true}
            />
          </div>
        )
      )}
    </div>

    {/* Display uploaded images */}
    <div className="flex flex-col md:flex-row flex-wrap gap-4 mt-8">
      {images.map((image, index) => (
        <div
          key={index}
          className="relative transition-transform duration-300 ease-in-out hover:scale-105 md:hover:scale-110 border border-[#d7d5e2] shadow rounded-lg w-[200px] md:w-[200px]"
        >
          <img
            src={image.ImagePath}
            alt="preview"
            className="h-[200px] lg:w-full sm:w-[200px] md:w-[200px] object-cover rounded-lg"
          />
          <button
            onClick={() => handleImageDelete(index)}
            className="cursor-pointer absolute right-1 bottom-1 bg-red-500 text-white rounded-full p-1"
          >
            <FaTimes />
          </button>
        </div>
      ))}
    </div>
  </div>
</PageSection>

        {/* Delivery Section */}
        {isPincode && (
          <PageSection title="Delivery">
            <div className="grid gap-6 mt-5">
              <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
                <Select
                  label="Delivery"
                  value={deliveryType}
                  options={[
                    { label: "Self Delivery", value: "self" },
                    { label: "Shadowfax", value: "shadowfax" },
                    ...(registration?.EnablePincodeDelivery ? [{ label: "Pincode", value: "pincode" }] : []),
                  ]}
                  onChange={(e) => setDeliveryType(e.target.value)}
                />
                <div className="grid gap-3">
                  <div className="flex items-center gap-2">
                    <Input
                      label="Ship Time"
                      type="number"
                      value={shipTime}
                      onChange={(e) => setShipTime(e.target.value)}
                    />
                    <Select
                      value={shipTimeType}
                      options={[
                        { label: "mins", value: "min" },
                        { label: "hrs", value: "hr" },
                        ...(registration?.EnablePincodeDelivery ? [{ label: "days", value: "day" }] : []),
                      ]}
                      onChange={(e) => setShipTimeType(e.target.value)}
                    />
                  </div>
                  <div className="flex items-center gap-2">
                    <Input
                      label="Delivery Time"
                      type="number"
                      value={deliveryTime}
                      onChange={(e) => setDeliveryTime(e.target.value)}
                    />
                    <Select
                      value={deliveryTimeType}
                      options={[
                        { label: "mins", value: "min" },
                        { label: "hrs", value: "hr" },
                        ...(registration?.EnablePincodeDelivery ? [{ label: "days", value: "day" }] : []),
                      ]}
                      onChange={(e) => setDeliveryTimeType(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div>
                <Input
                  label="Delivery Radius (kms)"
                  type="number"
                  value={deliveryRadius}
                  onChange={(e) => {
                    if (e.target.value <= 50) {
                      setDeliveryRadius(e.target.value);
                    }
                  }}
                />
                {deliveryType === "self" && registration?.EnablePincodeDeliveryCharges && (
                  <Input
                    label="Delivery Charge"
                    type="number"
                    value={deliveryCharge}
                    onChange={(e) => setDeliveryCharge(e.target.value)}
                  />
                )}
              </div>
            </div>
          </PageSection>
        )}

        {/* Settings Section */}
        <PageSection title="Settings">
          <div className="grid lg:grid-cols-4 gap-6 mt-5">
            <CustomSwitch
              formlabel="Accept online orders"
              infoText={"Accept Online Orders: Enable this option to allow your store to receive and process online orders directly through the system."}
              tooltipPosition="right"
              tooltipWidth={"500px"}
              checked={acceptOnlineOrders}
              onChange={(checked) => setAcceptOnlineOrders(checked)}
            />
            {acceptOnlineOrders && (
              <CustomSwitch
                formlabel="Auto accept online orders"
                checked={autoAcceptOnlineOrders}
                onChange={(checked) => setAutoAcceptOnlineOrders(checked)}
              />
            )}

            {!isPincode && (
              <>
                <CustomSwitch
                  infoText={"turn this on to make sure the system tracks daily sales and requires users to close the register at the end of the day or shift."}
                  tooltipPosition="top"
                  tooltipWidth={"500px"}
                  formlabel="Enable cash register closing"
                  checked={cashRegisterClosingSelected}
                  onChange={(checked) => setCashRegisterClosingSelected(checked)}
                />
                {cashRegisterClosingSelected && (
                  <CustomSwitch
                    formlabel="Show product sale details during cash register closing"
                    infoText={"When enabled, detailed product-wise sales information will be shown during the cash register closing process."}
                    tooltipPosition="top"
                    tooltipWidth={"400px"}
                    checked={cashRegisterClosingIncludeProductSaleDetails}
                    onChange={(checked) => setCashRegisterClosingIncludeProductSaleDetails(checked)}
                  />
                )}

                <CustomSwitch
                  formlabel="Negative product qty not allowed for billing"
                  infoText={"If enabled, the system will prevent billing items that have zero or negative stock to avoid overselling."}
                  tooltipPosition="left"
                  tooltipWidth={"500px"}
                  checked={negativeProductQtyNotAllowedForBilling}
                  onChange={(checked) => setNegativeProductQtyNotAllowedForBilling(checked)}
                />

                <CustomSwitch
                  formlabel="Change qty on price update"
                  infoText={"Turning this on will automatically adjust product quantity whenever you update the product price during billing or editing."}
                  tooltipPosition="right"
                  tooltipWidth={"500px"}
                  checked={changeQtyOnPriceUpdate}
                  onChange={(checked) => setChangeQtyOnPriceUpdate(checked)}
                />

                {urbanPiperIntegration && (
                  <CustomSwitch
                    formlabel="Enable food delivery platforms"
                    checked={enableFoodDeliveryPlatforms}
                    onChange={(checked) => setEnableFoodDeliveryPlatforms(checked)}
                  />
                )}

                <Select
                  label="Sales default product search"
                  infoText={"Select how products should be searched by default on the sales screen, such as Search Mode or Scan Mode."}
                  tooltipWidth={"500px"}
                  tooltipPosition="right"
                  value={salesProductSearch}
                  options={[
                    { label: "Search Mode", value: "1" },
                    { label: "Scan Mode", value: "2" },
                  ]}
                  onChange={(e) => setSalesProductSearch(e.target.value)}
                />

                <Select
                  label="Inventory default product search"
                  infoText={"Choose the default method for searching products in inventory sections like Search Mode or Scan Mode."}
                  tooltipWidth={"500px"}
                  tooltipPosition="top"
                  value={inventoryProductSearch}
                  options={[
                    { label: "Search Mode", value: "1" },
                    { label: "Scan Mode", value: "2" },
                  ]}
                  onChange={(e) => setInventoryProductSearch(e.target.value)}
                />

                {registration?.KOT && (
                  <Input
                    label="KOT Printer Name"
                    value={kotPrinter}
                    onChange={(e) => setKotPrinter(e.target.value)}
                  />
                )}

                <Select
                  label="Sales screen option"
                  infoText={"Pick the display layout of your sales screen, like a standard list view or a tile-based view, depending on your preference."}
                  tooltipPosition="left"
                  tooltipWidth={"500px"}
                  value={desktopOption}
                  options={[
                    { label: "Option 1", value: "1" },
                    { label: "Option 2", value: "2" },
                    { label: "Option 3", value: "3" },
                  ]}
                  onChange={(e) => setDesktopOption(e.target.value)}
                />

                {registration?.BillingCustomerRestriction && (
                  <CustomSwitch
                    formlabel="Disable customer creation and edit"
                    checked={disableCustomerCreationAndEdit}
                    onChange={(checked) => setDisableCustomerCreationAndEdit(checked)}
                  />
                )}

                <CustomSwitch
                  formlabel="Enable Table Order"
                     tooltipPosition="right"
                    infoText={"Use this option to activate table-wise order management, useful for restaurants or cafés to manage orders per table."}
                    tooltipWidth={"500px"}
                  checked={enableTableOrder}
                  onChange={(checked) => setEnableTableOrder(checked)}
                />

                {enableTableOrder && (
                  <Select
                    label="Transaction Type"
                    value={tableOrderTransactionTypeID}
                    options={salesTransactionTypes.map(transaction => ({
                      label: transaction.TransactionType,
                      value: transaction.key
                    }))}
                    onChange={(e) => setTableOrderTransactionTypeID(e.target.value)}
                  />
                )}

                {enableFoodDeliveryPlatforms && (
                  <>
                    <Input
                      type="number"
                      label="Min Order Value"
                      value={minOrderValue}
                      onChange={(e) => setMinOrderValue(e.target.value)}
                    />

                    <Input
                      label="Min Pickup Time"
                      value={minPickUptime}
                      type="number"
                      onChange={(e) => setMinPickUptime(e.target.value)}
                      endtext="Mins"
                    />

                    <Input
                      label="Min Delivery Time"
                      value={minDeliveryTime}
                      type="number"
                      onChange={(e) => setMinDeliveryTime(e.target.value)}
                      endtext="Mins"
                    />

                    <div className="overflow-x-auto">
                      <table className="table table-bordered table-striped w-full">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Delivery Platforms</th>
                            <th>Price Markup (%)</th>
                            <th>Transaction Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {foodDeliveryPlatforms.map((m, index) => (
                            <tr key={m.Code}>
                              <td>
                                <Input
                                  type="checkbox"
                                  checked={m.Selected || false}
                                  onChange={() => {
                                    const updatedPlatforms = [...foodDeliveryPlatforms];
                                    updatedPlatforms[index].Selected = !updatedPlatforms[index].Selected;
                                    setFoodDeliveryPlatforms(updatedPlatforms);
                                  }}
                                />
                              </td>
                              <td>{m.Name}</td>
                              <td>
                                {m.Selected && (
                                  <Input
                                    type="number"
                                    onChange={(e) => {
                                      const updatedPlatforms = [...foodDeliveryPlatforms];
                                      updatedPlatforms[index].PriceMarkUp = e.target.value;
                                      setFoodDeliveryPlatforms(updatedPlatforms);
                                    }}
                                    value={m.PriceMarkUp || ""}
                                  />
                                )}
                              </td>
                              <td>
                                {m.Selected && (
                                  <Select
                                    value={m.TransactionTypeID || ""}
                                    options={salesTransactionTypes.map(transaction => ({
                                      label: transaction.TransactionType,
                                      value: transaction.key
                                    }))}
                                    onChange={(e) => {
                                      const updatedPlatforms = [...foodDeliveryPlatforms];
                                      updatedPlatforms[index].TransactionTypeID = e.target.value;
                                      setFoodDeliveryPlatforms(updatedPlatforms);
                                    }}
                                  />
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </PageSection>

        {/* Store Timing Section */}
        <PageSection title="Store Timing">
          <div className="lg:p-4">
            <table className="w-full border border-gray-300">
              <thead className="">
                <tr className="bg-gray-100">
                  <th className="border p-2 font-semibold w-[120px]">Day</th>
                  <th className="border p-2 font-semibold w-[80px]">Open</th>
                  <th className="border p-2 font-semibold">Start Time</th>
                  <th className="border p-2 font-semibold">End Time</th>
                </tr>
              </thead>
              <tbody>
                {storeTiming.map((m, index) => (
                  <tr key={m.Day} className="odd:bg-gray-50">
                    <td className="border p-2 w-[120px]">{m.Day}</td>
                    <td className="border p-2 text-center w-[80px]">
                      <input
                        type="checkbox"
                        checked={m.Open}
                        onChange={() => {
                          const updatedStoreTiming = [...storeTiming];
                          updatedStoreTiming[index].Open = !updatedStoreTiming[index].Open;
                          setStoreTiming(updatedStoreTiming);
                        }}
                      />
                    </td>
                    <td className="border p-2">
                      {m.Open && (
                        <div className="grid lg:grid-cols-3 gap-2 items-center">
                          <Input
                            type="text"
                            className="w-12"
                            placeholder="HH"
                            value={m.StartTime.HH}
                            onChange={(e) => {
                              const updatedStoreTiming = [...storeTiming];
                              updatedStoreTiming[index].StartTime.HH = e.target.value;
                              setStoreTiming(updatedStoreTiming);
                            }}
                          />
                          <Input
                            type="text"
                            className="w-12"
                            placeholder="MM"
                            value={m.StartTime.MM}
                            onChange={(e) => {
                              const updatedStoreTiming = [...storeTiming];
                              updatedStoreTiming[index].StartTime.MM = e.target.value;
                              setStoreTiming(updatedStoreTiming);
                            }}
                          />
                          <Select
                            value={m.StartTime.AMPM}
                            onChange={(e) => {
                              const updatedStoreTiming = [...storeTiming];
                              updatedStoreTiming[index].StartTime.AMPM = e.target.value;
                              setStoreTiming(updatedStoreTiming);
                            }}
                            options={[
                              { label: "AM", value: "AM" },
                              { label: "PM", value: "PM" },
                            ]}
                          />
                        </div>
                      )}
                    </td>
                    <td className="border p-2">
                      {m.Open && (
                        <>
                          <div className="grid lg:grid-cols-3 gap-2 items-center">
                            <Input
                              type="number"
                              placeholder="HH"
                              value={m.EndTime.HH}
                              onChange={(e) => {
                                const updatedStoreTiming = [...storeTiming];
                                updatedStoreTiming[index].EndTime.HH = e.target.value;
                                setStoreTiming(updatedStoreTiming);
                              }}
                            />
                            <Input
                              type="number"
                              placeholder="MM"
                              value={m.EndTime.MM}
                              onChange={(e) => {
                                const updatedStoreTiming = [...storeTiming];
                                updatedStoreTiming[index].EndTime.MM = e.target.value;
                                setStoreTiming(updatedStoreTiming);
                              }}
                            />
                            <Select
                              value={m.EndTime.AMPM}
                              onChange={(e) => {
                                const updatedStoreTiming = [...storeTiming];
                                updatedStoreTiming[index].EndTime.AMPM = e.target.value;
                                setStoreTiming(updatedStoreTiming);
                              }}
                              options={[
                                { label: "AM", value: "AM" },
                                { label: "PM", value: "PM" },
                              ]}
                            />
                          </div>

                          {index === 0 && m.Open && (
                            <Button
                              type="secondary"
                              onClick={() => {
                                const updatedStoreTiming = [...storeTiming];
                                for (let i = 1; i < updatedStoreTiming.length; i++) {
                                  updatedStoreTiming[i].Open = m.Open;
                                  updatedStoreTiming[i].StartTime = { ...m.StartTime };
                                  updatedStoreTiming[i].EndTime = { ...m.EndTime };
                                }
                                setStoreTiming(updatedStoreTiming);
                              }}
                              className="mt-2"
                            >
                              Apply to all
                            </Button>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </PageSection>

        {/* Additional Information Section */}
        {!isPincode && (
          <PageSection title="Additional Information" showInfoIcon={true} performParentOnclick={()=>{setShowInfoModal(true), setInfoType("StoreAdditionalInformation") }}>
            <div className="grid gap-3 mt-5">
              <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-3">
                <Input
                  label={customFieldData?.CustomField1Name || "Custom Field 1"}
                  placeholder="Enter your Custom Field 1"
                  value={customField1}
                  onChange={(e) => setCustomField1(e.target.value)}
                />
                <Input
                  label={customFieldData?.CustomField2Name || "Custom Field 2"}
                  placeholder="Enter your Custom Field 2"
                  value={customField2}
                  onChange={(e) => setCustomField2(e.target.value)}
                />
                <Input
                  label={customFieldData?.CustomField3Name || "Custom Field 3"}
                  placeholder="Enter your Custom Field 3"
                  value={customField3}
                  onChange={(e) => setCustomField3(e.target.value)}
                />
                <Input
                  label={customFieldData?.CustomField4Name || "Custom Field 4"}
                  placeholder="Enter your Custom Field 4"
                  value={customField4}
                  onChange={(e) => setCustomField4(e.target.value)}
                />
                <Input
                  label={customFieldData?.CustomField5Name || "Custom Field 5"}
                  placeholder="Enter your Custom Field 5"
                  value={customField5}
                  onChange={(e) => setCustomField5(e.target.value)}
                />
                <Input
                  label={customFieldData?.CustomField6Name || "Custom Field 6"}
                  placeholder="Enter your Custom Field 6"
                  value={customField6}
                  onChange={(e) => setCustomField6(e.target.value)}
                />
              </div>
            </div>
          </PageSection>
        )}

      </div>}
        {showInfoModal &&
              <InfoModal
                type={infoType}
                setPopUp={setShowInfoModal}
                width="w-[50%]"
              />}
    </CreatePage>
  );
};

export default AddStoreData;